/**
 * 中国省份列表
 */
export const CHINA_PROVINCES = [
  '北京市', '天津市', '上海市', '重庆市',
  '河北省', '山西省', '辽宁省', '吉林省', '黑龙江省',
  '江苏省', '浙江省', '安徽省', '福建省', '江西省', '山东省',
  '河南省', '湖北省', '湖南省', '广东省',
  '海南省', '四川省', '贵州省', '云南省', '陕西省',
  '甘肃省', '青海省', '台湾省',
  '内蒙古自治区', '广西壮族自治区', '西藏自治区', '宁夏回族自治区', '新疆维吾尔自治区',
  '香港特别行政区', '澳门特别行政区',
] as const;

export type Province = typeof CHINA_PROVINCES[number];

/**
 * 模板ID到名称的映射
 */
export const TEMPLATE_NAME_MAP: Record<string, string> = {
  classic: '经典橙色',
  modern: '现代蓝色',
  dark: '深色商务',
  green: '清新绿意',
  red: '热情红色',
  'tech-blue': '科技蓝',
  'deep-blue': '深邃蓝',
  teal: '清新薄荷',
  sunset: '日落橙',
  purple: '极简紫韵',
};

/**
 * 根据模板ID获取显示名称
 */
export function getTemplateName(templateId?: string): string {
  if (!templateId) return '经典橙色';
  return TEMPLATE_NAME_MAP[templateId] || templateId;
}
